import React from "react";
import { OrgTabHeader, OrgEmptyState } from "./orgTabShell";

/**
 * Placeholder for org profile / settings in the admin app.
 * @param {Object} _props
 * @returns {JSX.Element}
 */
function OrganizationInfoTab(_props) {
  return (
    <div>
      <OrgTabHeader
        title="Organization info"
        description="Update how your organization appears to others."
      />
      <OrgEmptyState
        title="Coming soon"
        subtitle="Organization settings will be available here."
        className="border-solid bg-ui-card"
      />
    </div>
  );
}

export default OrganizationInfoTab;
